import { LOCALE } from "core/interfaces";

import type { Translation } from "~/common/interfaces/translation.interface";

export const translationNormalize = <T extends Translation>(translations: T[], keys: (keyof T)[]) => {
	// @ts-ignore
	const res: Record<keyof T, Record<LOCALE, string>> = {};

	translations.forEach((translation) => {
		keys.forEach((key) => {
			if (!res[key]) {
				// @ts-ignore
				res[key] = {};
			}

			res[key][translation.locale] = translation[key] || "";
		});
	});

	return res;
};
